import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditSystemMultipleComponent } from './EditSystemMultiple.component';
import { DxDropDownBoxModule,DxButtonModule, DxCheckBoxModule, DxDropDownButtonModule, DxNumberBoxModule, DxPopupModule, DxScrollViewModule, DxSelectBoxModule, DxSwitchModule, DxTextAreaModule, DxTextBoxModule, DxTreeViewModule, DxTagBoxModule, DxDataGridModule } from 'devextreme-angular';
import { MdbGlobalModule } from '../mdb-global.module';
import { SystemControllerModule } from 'src/app/pages/estimation/system-controller/system-controller.module';



@NgModule({
  declarations: [EditSystemMultipleComponent],
  imports: [
    CommonModule,
    MdbGlobalModule,
    DxTreeViewModule,
    DxButtonModule,
    DxDropDownButtonModule,
    DxPopupModule,
    DxScrollViewModule,
    DxCheckBoxModule,
    DxTextBoxModule,
    DxNumberBoxModule,
    DxTextAreaModule,
    DxSelectBoxModule,
    DxSwitchModule,
    DxDropDownBoxModule,
    SystemControllerModule,
    DxTagBoxModule,
    DxDataGridModule
  ],
  exports: [EditSystemMultipleComponent]
})
export class EditSystemMultipleModule { }
